import type { PricingGridRow } from "./types"

export const MAX_TIERS_PER_GROUP = 10

export const MAX_SURCHARGES_PER_ROW = 3

export const BLANK_PRICING_TIER: Partial<PricingGridRow> = {
  qty: 0,
  newPrice: 0,
  newProfit: 0,
  newMargin: 0,
  surcharge1Price: 0,
  surcharge1Description: null,
  surcharge2Price: 0,
  surcharge2Description: null,
  surcharge3Price: 0,
  surcharge3Description: null,
}
